import { Quote, MapPin, BadgeCheck } from "lucide-react";
import { Reveal, Eyebrow, SectionTitle } from "./Reveal";
import { TESTIMONIALS } from "@/data/content";

export default function TestimonialsSection() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="mx-auto max-w-7xl px-4 py-24 sm:px-6"
    >
      <Reveal>
        <div className="mb-12">
          <Eyebrow>Client Accolades</Eyebrow>
          <SectionTitle className="mt-3">
            Trusted by <span className="text-brand">Serious Capital</span>
          </SectionTitle>
        </div>
      </Reveal>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.07}>
            <figure
              data-testid={`testimonial-card-${i}`}
              className="card-trace flex h-full flex-col rounded-xl border border-line bg-panel p-7"
            >
              <Quote size={22} className="text-brand" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-mute sm:text-base">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-4 border-t border-line pt-5">
                <img
                  src={t.avatar}
                  alt={`Portrait of ${t.name}`}
                  loading="lazy"
                  className="h-12 w-12 rounded-full border border-line object-cover"
                />
                <div className="flex-1">
                  <p className="font-sans text-sm font-bold text-ink">{t.name}</p>
                  <p className="text-xs text-dim">{t.role}</p>
                  <p className="mt-0.5 flex items-center gap-1 font-mono text-[10px] uppercase tracking-[0.15em] text-dim">
                    <MapPin size={10} /> {t.location}
                  </p>
                </div>
                <span className="hidden items-center gap-1.5 rounded-full border border-gold/40 bg-gold/10 px-3 py-1.5 font-mono text-[9px] font-bold uppercase tracking-[0.12em] text-gold sm:inline-flex">
                  <BadgeCheck size={11} />
                  {t.aum}
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
